<template>
    <section class="breadcrumbs-custom">
        <div class="parallax-container">
          <div class="material-parallax parallax"><img src="/assets/images/custom_cakes_1.png" alt="breadcrumbs"></div>
          <div class="breadcrumbs-custom-body parallax-content context-dark">
            <div class="container">
                <!-- <h2 class="breadcrumbs-custom-title">Custom Cakes Categories</h2> -->
                <h3>CakeGurus is happy to design a cake for any occasion. Let your imagination run wild!</h3>
                <p>Custom cakes are priced by the size, flavour and complexity of design. Please send us the inquiry form attached to each photo to get a quote for a specific cake.</p>
            </div>
          </div>
        </div>
        <div class="breadcrumbs-custom-footer">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><router-link to="/" class="rd-nav-link">Home</router-link></li>
              <li class="active">Custom Cakes Categories</li>
            </ul>
          </div>
        </div>
    </section>

    <!-- <section class="section section-xl bg-default">
      <div class="container ">
        <div class="row row-30 " >
          <div class="col-sm-6 col-lg-4 " v-for="category in categories" :key="category.id">
            <article class="thumbnail-classic">
              <div class="thumbnail-classic-figure">
                <image-component
                  :path="category.image"
                  disk="images"
                  :skeletonWidth="`370px`"
                  :skeletonHeight="`315px`"
                  :width="`370px`"
                  :height="`315px`"
                />
              </div>
              <div class="thumbnail-classic-caption">
                <div>
                  <h5 class="thumbnail-classic-title"><a href="#">{{ category.name }}</a></h5>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section> -->

    <section class="section section-sm section-last bg-default">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-3 col-lg-4 col-xl-4 py-4" v-for="category in categories" :key="category.id">
                    <article class="box-info-modern wow slideInUp" data-wow-delay=".1s">
                      <router-link  class="box-info-modern-figure" :to="{ name: 'custom-cake', params: { category_slug: category.slug } }">
                        <!-- <image-component
                          :path="category.image"
                          disk="images"
                          :skeletonWidth="`340px`"
                          :skeletonHeight="`243px`"
                          :width="`340px`"
                          :height="`243px`"
                        /> -->
                        <img :src="category.image" :alt="category.name" width="340" height="243">
                      </router-link>
                      <router-link  class="box-info-modern-link" :to="{ name: 'custom-cake', params: { category_slug: category.slug } }">{{ category.name }}</router-link>
                    </article>
                </div>
            </div>
        </div>
    </section>

</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useHead } from '@unhead/vue'
import { api } from '@/plugins/axios';
import { useCartStore } from '@/stores/cart'
import { useCommonStore } from "@/stores/commonStore";

const cartStore = useCartStore()
const commonStore = useCommonStore();
const categories = ref([]);

useHead({
  title: 'CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Welcome to CakeGurus.',
    },
  ],
})

onMounted(async () => {
    commonStore.loaderVisible = true;   
    cartStore.loadCart()
    await getCustomCakeCategories();   

    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)      

    commonStore.loaderVisible = false;
})

async function getCustomCakeCategories() {
  try {
    const response = await api.get('/get-custom-cake-categories')        
    categories.value = response.data.results
  } catch (error) {
    console.error('Error fetching categories:', error)
  }
}

</script>
<style scoped>
.material-parallax img { 
  position: relative;
  filter: brightness(0.5);
}
</style>